import * as Yup from "yup";

export const DEFAULT_VALUES = {
  name: "",
  permissions: {},
};

export const VALIDATION_SCHEMA = Yup.object().shape({
  name: Yup.string().required("Harus diisi"),
  permissions: Yup.object()
    .required()
    .test("at-least-one-true", "Minimal 1 permission harus dipilih", (value) =>
      Object.values(value).some((value) => value)
    ),
});
